interface CountryItem {
    label: string;
    callingCodes?: string[];
}

export const CountriesList: CountryItem[] = [
    {
        'label': 'Afghanistan',
        'callingCodes': [
            '93'
        ]
    },
    {
        'label': 'Åland Islands',
        'callingCodes': [
            '358'
        ]
    },
    {
        'label': 'Albania',
        'callingCodes': [
            '355'
        ]
    },
    {
        'label': 'Algeria',
        'callingCodes': [
            '213'
        ]
    },
    {
        'label': 'American Samoa',
        'callingCodes': [
            '1684'
        ]
    },
    {
        'label': 'Andorra',
        'callingCodes': [
            '376'
        ]
    },
    {
        'label': 'Angola',
        'callingCodes': [
            '244'
        ]
    },
    {
        'label': 'Anguilla',
        'callingCodes': [
            '1264'
        ]
    },
    {
        'label': 'Antarctica',
        'callingCodes': [
            '672'
        ]
    },
    {
        'label': 'Antigua and Barbuda',
        'callingCodes': [
            '1268'
        ]
    },
    {
        'label': 'Argentina',
        'callingCodes': [
            '54'
        ]
    },
    {
        'label': 'Armenia',
        'callingCodes': [
            '374'
        ]
    },
    {
        'label': 'Aruba',
        'callingCodes': [
            '297'
        ]
    },
    {
        'label': 'Australia',
        'callingCodes': [
            '61'
        ]
    },
    {
        'label': 'Austria',
        'callingCodes': [
            '43'
        ]
    },
    {
        'label': 'Azerbaijan',
        'callingCodes': [
            '994'
        ]
    },
    {
        'label': 'Bahamas',
        'callingCodes': [
            '1242'
        ]
    },
    {
        'label': 'Bahrain',
        'callingCodes': [
            '973'
        ]
    },
    {
        'label': 'Bangladesh',
        'callingCodes': [
            '880'
        ]
    },
    {
        'label': 'Barbados',
        'callingCodes': [
            '1246'
        ]
    },
    {
        'label': 'Belarus',
        'callingCodes': [
            '375'
        ]
    },
    {
        'label': 'Belgium',
        'callingCodes': [
            '32'
        ]
    },
    {
        'label': 'Belize',
        'callingCodes': [
            '501'
        ]
    },
    {
        'label': 'Benin',
        'callingCodes': [
            '229'
        ]
    },
    {
        'label': 'Bermuda',
        'callingCodes': [
            '1441'
        ]
    },
    {
        'label': 'Bhutan',
        'callingCodes': [
            '975'
        ]
    },
    {
        'label': 'Bolivia (Plurinational State of)',
        'callingCodes': [
            '591'
        ]
    },
    {
        'label': 'Bonaire, Sint Eustatius and Saba',
        'callingCodes': [
            '5997'
        ]
    },
    {
        'label': 'Bosnia and Herzegovina',
        'callingCodes': [
            '387'
        ]
    },
    {
        'label': 'Botswana',
        'callingCodes': [
            '267'
        ]
    },
    {
        'label': 'Bouvet Island',
        'callingCodes': [
            ''
        ]
    },
    {
        'label': 'Brazil',
        'callingCodes': [
            '55'
        ]
    },
    {
        'label': 'British Indian Ocean Territory',
        'callingCodes': [
            '246'
        ]
    },
    {
        'label': 'United States Minor Outlying Islands',
        'callingCodes': [
            ''
        ]
    },
    {
        'label': 'Virgin Islands (British)',
        'callingCodes': [
            '1284'
        ]
    },
    {
        'label': 'Virgin Islands (U.S.)',
        'callingCodes': [
            '1 340'
        ]
    },
    {
        'label': 'Brunei Darussalam',
        'callingCodes': [
            '673'
        ]
    },
    {
        'label': 'Bulgaria',
        'callingCodes': [
            '359'
        ]
    },
    {
        'label': 'Burkina Faso',
        'callingCodes': [
            '226'
        ]
    },
    {
        'label': 'Burundi',
        'callingCodes': [
            '257'
        ]
    },
    {
        'label': 'Cambodia',
        'callingCodes': [
            '855'
        ]
    },
    {
        'label': 'Cameroon',
        'callingCodes': [
            '237'
        ]
    },
    {
        'label': 'Canada',
        'callingCodes': [
            '1'
        ]
    },
    {
        'label': 'Cabo Verde',
        'callingCodes': [
            '238'
        ]
    },
    {
        'label': 'Cayman Islands',
        'callingCodes': [
            '1345'
        ]
    },
    {
        'label': 'Central African Republic',
        'callingCodes': [
            '236'
        ]
    },
    {
        'label': 'Chad',
        'callingCodes': [
            '235'
        ]
    },
    {
        'label': 'Chile',
        'callingCodes': [
            '56'
        ]
    },
    {
        'label': 'China',
        'callingCodes': [
            '86'
        ]
    },
    {
        'label': 'Christmas Island',
        'callingCodes': [
            '61'
        ]
    },
    {
        'label': 'Cocos (Keeling) Islands',
        'callingCodes': [
            '61'
        ]
    },
    {
        'label': 'Colombia',
        'callingCodes': [
            '57'
        ]
    },
    {
        'label': 'Comoros',
        'callingCodes': [
            '269'
        ]
    },
    {
        'label': 'Congo',
        'callingCodes': [
            '242'
        ]
    },
    {
        'label': 'Congo (Democratic Republic of the)',
        'callingCodes': [
            '243'
        ]
    },
    {
        'label': 'Cook Islands',
        'callingCodes': [
            '682'
        ]
    },
    {
        'label': 'Costa Rica',
        'callingCodes': [
            '506'
        ]
    },
    {
        'label': 'Croatia',
        'callingCodes': [
            '385'
        ]
    },
    {
        'label': 'Cuba',
        'callingCodes': [
            '53'
        ]
    },
    {
        'label': 'Curaçao',
        'callingCodes': [
            '599'
        ]
    },
    {
        'label': 'Cyprus',
        'callingCodes': [
            '357'
        ]
    },
    {
        'label': 'Czech Republic',
        'callingCodes': [
            '420'
        ]
    },
    {
        'label': 'Denmark',
        'callingCodes': [
            '45'
        ]
    },
    {
        'label': 'Djibouti',
        'callingCodes': [
            '253'
        ]
    },
    {
        'label': 'Dominica',
        'callingCodes': [
            '1767'
        ]
    },
    {
        'label': 'Dominican Republic',
        'callingCodes': [
            '1809',
            '1829',
            '1849'
        ]
    },
    {
        'label': 'Ecuador',
        'callingCodes': [
            '593'
        ]
    },
    {
        'label': 'Egypt',
        'callingCodes': [
            '20'
        ]
    },
    {
        'label': 'El Salvador',
        'callingCodes': [
            '503'
        ]
    },
    {
        'label': 'Equatorial Guinea',
        'callingCodes': [
            '240'
        ]
    },
    {
        'label': 'Eritrea',
        'callingCodes': [
            '291'
        ]
    },
    {
        'label': 'Estonia',
        'callingCodes': [
            '372'
        ]
    },
    {
        'label': 'Ethiopia',
        'callingCodes': [
            '251'
        ]
    },
    {
        'label': 'Falkland Islands (Malvinas)',
        'callingCodes': [
            '500'
        ]
    },
    {
        'label': 'Faroe Islands',
        'callingCodes': [
            '298'
        ]
    },
    {
        'label': 'Fiji',
        'callingCodes': [
            '679'
        ]
    },
    {
        'label': 'Finland',
        'callingCodes': [
            '358'
        ]
    },
    {
        'label': 'France',
        'callingCodes': [
            '33'
        ]
    },
    {
        'label': 'French Guiana',
        'callingCodes': [
            '594'
        ]
    },
    {
        'label': 'French Polynesia',
        'callingCodes': [
            '689'
        ]
    },
    {
        'label': 'French Southern Territories',
        'callingCodes': [
            ''
        ]
    },
    {
        'label': 'Gabon',
        'callingCodes': [
            '241'
        ]
    },
    {
        'label': 'Gambia',
        'callingCodes': [
            '220'
        ]
    },
    {
        'label': 'Georgia',
        'callingCodes': [
            '995'
        ]
    },
    {
        'label': 'Germany',
        'callingCodes': [
            '49'
        ]
    },
    {
        'label': 'Ghana',
        'callingCodes': [
            '233'
        ]
    },
    {
        'label': 'Gibraltar',
        'callingCodes': [
            '350'
        ]
    },
    {
        'label': 'Greece',
        'callingCodes': [
            '30'
        ]
    },
    {
        'label': 'Greenland',
        'callingCodes': [
            '299'
        ]
    },
    {
        'label': 'Grenada',
        'callingCodes': [
            '1473'
        ]
    },
    {
        'label': 'Guadeloupe',
        'callingCodes': [
            '590'
        ]
    },
    {
        'label': 'Guam',
        'callingCodes': [
            '1671'
        ]
    },
    {
        'label': 'Guatemala',
        'callingCodes': [
            '502'
        ]
    },
    {
        'label': 'Guernsey',
        'callingCodes': [
            '44'
        ]
    },
    {
        'label': 'Guinea',
        'callingCodes': [
            '224'
        ]
    },
    {
        'label': 'Guinea-Bissau',
        'callingCodes': [
            '245'
        ]
    },
    {
        'label': 'Guyana',
        'callingCodes': [
            '592'
        ]
    },
    {
        'label': 'Haiti',
        'callingCodes': [
            '509'
        ]
    },
    {
        'label': 'Heard Island and McDonald Islands',
        'callingCodes': [
            ''
        ]
    },
    {
        'label': 'Holy See',
        'callingCodes': [
            '379'
        ]
    },
    {
        'label': 'Honduras',
        'callingCodes': [
            '504'
        ]
    },
    {
        'label': 'Hong Kong',
        'callingCodes': [
            '852'
        ]
    },
    {
        'label': 'Hungary',
        'callingCodes': [
            '36'
        ]
    },
    {
        'label': 'Iceland',
        'callingCodes': [
            '354'
        ]
    },
    {
        'label': 'India',
        'callingCodes': [
            '91'
        ]
    },
    {
        'label': 'Indonesia',
        'callingCodes': [
            '62'
        ]
    },
    {
        'label': 'Côte d\'Ivoire',
        'callingCodes': [
            '225'
        ]
    },
    {
        'label': 'Iran (Islamic Republic of)',
        'callingCodes': [
            '98'
        ]
    },
    {
        'label': 'Iraq',
        'callingCodes': [
            '964'
        ]
    },
    {
        'label': 'Ireland',
        'callingCodes': [
            '353'
        ]
    },
    {
        'label': 'Isle of Man',
        'callingCodes': [
            '44'
        ]
    },
    {
        'label': 'Israel',
        'callingCodes': [
            '972'
        ]
    },
    {
        'label': 'Italy',
        'callingCodes': [
            '39'
        ]
    },
    {
        'label': 'Jamaica',
        'callingCodes': [
            '1876'
        ]
    },
    {
        'label': 'Japan',
        'callingCodes': [
            '81'
        ]
    },
    {
        'label': 'Jersey',
        'callingCodes': [
            '44'
        ]
    },
    {
        'label': 'Jordan',
        'callingCodes': [
            '962'
        ]
    },
    {
        'label': 'Kazakhstan',
        'callingCodes': [
            '76',
            '77'
        ]
    },
    {
        'label': 'Kenya',
        'callingCodes': [
            '254'
        ]
    },
    {
        'label': 'Kiribati',
        'callingCodes': [
            '686'
        ]
    },
    {
        'label': 'Kuwait',
        'callingCodes': [
            '965'
        ]
    },
    {
        'label': 'Kyrgyzstan',
        'callingCodes': [
            '996'
        ]
    },
    {
        'label': 'Lao People\'s Democratic Republic',
        'callingCodes': [
            '856'
        ]
    },
    {
        'label': 'Latvia',
        'callingCodes': [
            '371'
        ]
    },
    {
        'label': 'Lebanon',
        'callingCodes': [
            '961'
        ]
    },
    {
        'label': 'Lesotho',
        'callingCodes': [
            '266'
        ]
    },
    {
        'label': 'Liberia',
        'callingCodes': [
            '231'
        ]
    },
    {
        'label': 'Libya',
        'callingCodes': [
            '218'
        ]
    },
    {
        'label': 'Liechtenstein',
        'callingCodes': [
            '423'
        ]
    },
    {
        'label': 'Lithuania',
        'callingCodes': [
            '370'
        ]
    },
    {
        'label': 'Luxembourg',
        'callingCodes': [
            '352'
        ]
    },
    {
        'label': 'Macao',
        'callingCodes': [
            '853'
        ]
    },
    {
        'label': 'Macedonia (the former Yugoslav Republic of)',
        'callingCodes': [
            '389'
        ]
    },
    {
        'label': 'Madagascar',
        'callingCodes': [
            '261'
        ]
    },
    {
        'label': 'Malawi',
        'callingCodes': [
            '265'
        ]
    },
    {
        'label': 'Malaysia',
        'callingCodes': [
            '60'
        ]
    },
    {
        'label': 'Maldives',
        'callingCodes': [
            '960'
        ]
    },
    {
        'label': 'Mali',
        'callingCodes': [
            '223'
        ]
    },
    {
        'label': 'Malta',
        'callingCodes': [
            '356'
        ]
    },
    {
        'label': 'Marshall Islands',
        'callingCodes': [
            '692'
        ]
    },
    {
        'label': 'Martinique',
        'callingCodes': [
            '596'
        ]
    },
    {
        'label': 'Mauritania',
        'callingCodes': [
            '222'
        ]
    },
    {
        'label': 'Mauritius',
        'callingCodes': [
            '230'
        ]
    },
    {
        'label': 'Mayotte',
        'callingCodes': [
            '262'
        ]
    },
    {
        'label': 'Mexico',
        'callingCodes': [
            '52'
        ]
    },
    {
        'label': 'Micronesia (Federated States of)',
        'callingCodes': [
            '691'
        ]
    },
    {
        'label': 'Moldova (Republic of)',
        'callingCodes': [
            '373'
        ]
    },
    {
        'label': 'Monaco',
        'callingCodes': [
            '377'
        ]
    },
    {
        'label': 'Mongolia',
        'callingCodes': [
            '976'
        ]
    },
    {
        'label': 'Montenegro',
        'callingCodes': [
            '382'
        ]
    },
    {
        'label': 'Montserrat',
        'callingCodes': [
            '1664'
        ]
    },
    {
        'label': 'Morocco',
        'callingCodes': [
            '212'
        ]
    },
    {
        'label': 'Mozambique',
        'callingCodes': [
            '258'
        ]
    },
    {
        'label': 'Myanmar',
        'callingCodes': [
            '95'
        ]
    },
    {
        'label': 'Namibia',
        'callingCodes': [
            '264'
        ]
    },
    {
        'label': 'Nauru',
        'callingCodes': [
            '674'
        ]
    },
    {
        'label': 'Nepal',
        'callingCodes': [
            '977'
        ]
    },
    {
        'label': 'Netherlands',
        'callingCodes': [
            '31'
        ]
    },
    {
        'label': 'New Caledonia',
        'callingCodes': [
            '687'
        ]
    },
    {
        'label': 'New Zealand',
        'callingCodes': [
            '64'
        ]
    },
    {
        'label': 'Nicaragua',
        'callingCodes': [
            '505'
        ]
    },
    {
        'label': 'Niger',
        'callingCodes': [
            '227'
        ]
    },
    {
        'label': 'Nigeria',
        'callingCodes': [
            '234'
        ]
    },
    {
        'label': 'Niue',
        'callingCodes': [
            '683'
        ]
    },
    {
        'label': 'Norfolk Island',
        'callingCodes': [
            '672'
        ]
    },
    {
        'label': 'Korea (Democratic People\'s Republic of)',
        'callingCodes': [
            '850'
        ]
    },
    {
        'label': 'Northern Mariana Islands',
        'callingCodes': [
            '1670'
        ]
    },
    {
        'label': 'Norway',
        'callingCodes': [
            '47'
        ]
    },
    {
        'label': 'Oman',
        'callingCodes': [
            '968'
        ]
    },
    {
        'label': 'Pakistan',
        'callingCodes': [
            '92'
        ]
    },
    {
        'label': 'Palau',
        'callingCodes': [
            '680'
        ]
    },
    {
        'label': 'Palestine, State of',
        'callingCodes': [
            '970'
        ]
    },
    {
        'label': 'Panama',
        'callingCodes': [
            '507'
        ]
    },
    {
        'label': 'Papua New Guinea',
        'callingCodes': [
            '675'
        ]
    },
    {
        'label': 'Paraguay',
        'callingCodes': [
            '595'
        ]
    },
    {
        'label': 'Peru',
        'callingCodes': [
            '51'
        ]
    },
    {
        'label': 'Philippines',
        'callingCodes': [
            '63'
        ]
    },
    {
        'label': 'Pitcairn',
        'callingCodes': [
            '64'
        ]
    },
    {
        'label': 'Poland',
        'callingCodes': [
            '48'
        ]
    },
    {
        'label': 'Portugal',
        'callingCodes': [
            '351'
        ]
    },
    {
        'label': 'Puerto Rico',
        'callingCodes': [
            '1787',
            '1939'
        ]
    },
    {
        'label': 'Qatar',
        'callingCodes': [
            '974'
        ]
    },
    {
        'label': 'Republic of Kosovo',
        'callingCodes': [
            '383'
        ]
    },
    {
        'label': 'Réunion',
        'callingCodes': [
            '262'
        ]
    },
    {
        'label': 'Romania',
        'callingCodes': [
            '40'
        ]
    },
    {
        'label': 'Russian Federation',
        'callingCodes': [
            '7'
        ]
    },
    {
        'label': 'Rwanda',
        'callingCodes': [
            '250'
        ]
    },
    {
        'label': 'Saint Barthélemy',
        'callingCodes': [
            '590'
        ]
    },
    {
        'label': 'Saint Helena, Ascension and Tristan da Cunha',
        'callingCodes': [
            '290'
        ]
    },
    {
        'label': 'Saint Kitts and Nevis',
        'callingCodes': [
            '1869'
        ]
    },
    {
        'label': 'Saint Lucia',
        'callingCodes': [
            '1758'
        ]
    },
    {
        'label': 'Saint Martin (French part)',
        'callingCodes': [
            '590'
        ]
    },
    {
        'label': 'Saint Pierre and Miquelon',
        'callingCodes': [
            '508'
        ]
    },
    {
        'label': 'Saint Vincent and the Grenadines',
        'callingCodes': [
            '1784'
        ]
    },
    {
        'label': 'Samoa',
        'callingCodes': [
            '685'
        ]
    },
    {
        'label': 'San Marino',
        'callingCodes': [
            '378'
        ]
    },
    {
        'label': 'Sao Tome and Principe',
        'callingCodes': [
            '239'
        ]
    },
    {
        'label': 'Saudi Arabia',
        'callingCodes': [
            '966'
        ]
    },
    {
        'label': 'Senegal',
        'callingCodes': [
            '221'
        ]
    },
    {
        'label': 'Serbia',
        'callingCodes': [
            '381'
        ]
    },
    {
        'label': 'Seychelles',
        'callingCodes': [
            '248'
        ]
    },
    {
        'label': 'Sierra Leone',
        'callingCodes': [
            '232'
        ]
    },
    {
        'label': 'Singapore',
        'callingCodes': [
            '65'
        ]
    },
    {
        'label': 'Sint Maarten (Dutch part)',
        'callingCodes': [
            '1721'
        ]
    },
    {
        'label': 'Slovakia',
        'callingCodes': [
            '421'
        ]
    },
    {
        'label': 'Slovenia',
        'callingCodes': [
            '386'
        ]
    },
    {
        'label': 'Solomon Islands',
        'callingCodes': [
            '677'
        ]
    },
    {
        'label': 'Somalia',
        'callingCodes': [
            '252'
        ]
    },
    {
        'label': 'South Africa',
        'callingCodes': [
            '27'
        ]
    },
    {
        'label': 'South Georgia and the South Sandwich Islands',
        'callingCodes': [
            '500'
        ]
    },
    {
        'label': 'Korea (Republic of)',
        'callingCodes': [
            '82'
        ]
    },
    {
        'label': 'South Sudan',
        'callingCodes': [
            '211'
        ]
    },
    {
        'label': 'Spain',
        'callingCodes': [
            '34'
        ]
    },
    {
        'label': 'Sri Lanka',
        'callingCodes': [
            '94'
        ]
    },
    {
        'label': 'Sudan',
        'callingCodes': [
            '249'
        ]
    },
    {
        'label': 'Surilabel',
        'callingCodes': [
            '597'
        ]
    },
    {
        'label': 'Svalbard and Jan Mayen',
        'callingCodes': [
            '4779'
        ]
    },
    {
        'label': 'Swaziland',
        'callingCodes': [
            '268'
        ]
    },
    {
        'label': 'Sweden',
        'callingCodes': [
            '46'
        ]
    },
    {
        'label': 'Switzerland',
        'callingCodes': [
            '41'
        ]
    },
    {
        'label': 'Syrian Arab Republic',
        'callingCodes': [
            '963'
        ]
    },
    {
        'label': 'Taiwan',
        'callingCodes': [
            '886'
        ]
    },
    {
        'label': 'Tajikistan',
        'callingCodes': [
            '992'
        ]
    },
    {
        'label': 'Tanzania, United Republic of',
        'callingCodes': [
            '255'
        ]
    },
    {
        'label': 'Thailand',
        'callingCodes': [
            '66'
        ]
    },
    {
        'label': 'Timor-Leste',
        'callingCodes': [
            '670'
        ]
    },
    {
        'label': 'Togo',
        'callingCodes': [
            '228'
        ]
    },
    {
        'label': 'Tokelau',
        'callingCodes': [
            '690'
        ]
    },
    {
        'label': 'Tonga',
        'callingCodes': [
            '676'
        ]
    },
    {
        'label': 'Trinidad and Tobago',
        'callingCodes': [
            '1868'
        ]
    },
    {
        'label': 'Tunisia',
        'callingCodes': [
            '216'
        ]
    },
    {
        'label': 'Turkey',
        'callingCodes': [
            '90'
        ]
    },
    {
        'label': 'Turkmenistan',
        'callingCodes': [
            '993'
        ]
    },
    {
        'label': 'Turks and Caicos Islands',
        'callingCodes': [
            '1649'
        ]
    },
    {
        'label': 'Tuvalu',
        'callingCodes': [
            '688'
        ]
    },
    {
        'label': 'Uganda',
        'callingCodes': [
            '256'
        ]
    },
    {
        'label': 'Ukraine',
        'callingCodes': [
            '380'
        ]
    },
    {
        'label': 'United Arab Emirates',
        'callingCodes': [
            '971'
        ]
    },
    {
        'label': 'United Kingdom of Great Britain and Northern Ireland',
        'callingCodes': [
            '44'
        ]
    },
    {
        'label': 'United States of America',
        'callingCodes': [
            '1'
        ]
    },
    {
        'label': 'Uruguay',
        'callingCodes': [
            '598'
        ]
    },
    {
        'label': 'Uzbekistan',
        'callingCodes': [
            '998'
        ]
    },
    {
        'label': 'Vanuatu',
        'callingCodes': [
            '678'
        ]
    },
    {
        'label': 'Venezuela (Bolivarian Republic of)',
        'callingCodes': [
            '58'
        ]
    },
    {
        'label': 'Viet Nam',
        'callingCodes': [
            '84'
        ]
    },
    {
        'label': 'Wallis and Futuna',
        'callingCodes': [
            '681'
        ]
    },
    {
        'label': 'Western Sahara',
        'callingCodes': [
            '212'
        ]
    },
    {
        'label': 'Yemen',
        'callingCodes': [
            '967'
        ]
    },
    {
        'label': 'Zambia',
        'callingCodes': [
            '260'
        ]
    },
    {
        'label': 'Zimbabwe',
        'callingCodes': [
            '263'
        ]
    }
];


